module.exports = __webpack_public_path__ + "media/images/applicant/attention-square-6c27816d321c77e19d6e368f9c668ecb.svg";